module.exports = __webpack_public_path__ + "static/img/sj_cjbg_2.a46d093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_cjbg_2.png
// module id = vtoA
// module chunks = 1